import { ProductPagination } from "./ProductPagination";
import { ProductList } from "./ProductList";
import React, { memo, useEffect } from "react";

export const ProductContainer = memo(({ itemGroups, pagedItemGroups, setPagedItemGroups, isLoading, cartModel }) => {

    useEffect(() => {
        $('.sponsored-label').each(function (index, element) {
            $(element).find('a').popover({
                html: true,
                placement: 'top',
                trigger: 'hover',
                content: function () {
                    return $('#sponsored-popover-content').html();
                }
            });
        });
    });

    return (
        <div className="tw-w-full">
            <div id="product-container"
                className={"row tw-gap-y-[25px] md:tw-gap-y-[43px] tw-mx-0 tw-content-baseline tw-w-full " + (!!cartModel ? "tw-gap-x-[2.5%] md:tw-gap-x-[4.5%]" : "tw-gap-x-[2.5%] md:tw-gap-x-[1.3%]")}>
                {pagedItemGroups.length < 1 && (
                    <div className="error-msg tk-trade-gothic-next tw-text-[17px] tw-w-full md:tw-w-auto">
                        No items found. Please try reloading this page.
                    </div>
                )}
                <ProductList pagedItemGroups={pagedItemGroups} isLoading={isLoading} cartModel={cartModel} />
                <ProductPagination itemGroups={itemGroups} setPagedItemGroups={setPagedItemGroups} isLoading={isLoading} cartModel={cartModel} />
            </div>
            {isLoading &&
                <div id="AnimationContainer" className="row" style={{ width: "80%" }}>
                    <div className="col-md-12" style={{ textAlign: "center" }} >
                        <i className="fas fa-spinner fa-spin" id="SpinnerAnimation"></i>
                    </div>
                </div>
            }
        </div>
    );
})